import { Avatar, Badge, Popover } from 'antd';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { InfoWraper, UserDropDwon } from './UserInfoStyle';
import AppAtag from '@/components/AppAtag';
import React from 'react';
import { useAppContext } from '@/contexts/AppContext';
import { useTranslation } from 'react-i18next';
import UpdateProfileModal from '@/components/modals/UpdateProfileModal';
import ChangePasswordModal from '@/components/modals/ChangePasswordModal';
import SupervisorPinModal from '@/components/modals/SupervisorPinModal';
import { SupervisorPinStatusModel } from '@/__generated';
import { apiSdk } from '@/httpClient';
import LanguageSelector from '@/components/app/LanguageSelector';

const languages = [
  {
    lang: 'en',
    flag: require('@/assets/images/flags/uk.png'),
    name: 'English',
  },
  {
    lang: 'fr',
    flag: require('@/assets/images/flags/fr.png'),
    name: 'Français',
  },
];
const LanguageDropdownContent = () => {
  const { i18n } = useTranslation();
  const changeLanguage = (l: string, e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    i18n.changeLanguage(l);
    window.location.reload();
  };

  return (
    <div>
      {languages.map(l => {
        return (
          <Link
            style={{ marginTop: 5, display: 'block' }}
            to="#"
            onClick={e => {
              changeLanguage(l.lang, e);
            }}
          >
            <img src={l.flag} alt={l.name} style={{ width: 20, marginRight: 10, borderRadius: 2 }} />
            <span style={{ color: 'rgb(90, 95, 125)' }}>{l.name}</span>
          </Link>
        );
      })}
    </div>
  );
};
const AuthInfo = () => {
  const { i18n, t } = useTranslation();
  const [showUserMenu, toggleUserMenu] = React.useState<boolean>(false);
  const [showChangePass, toggleChangePass] = React.useState<boolean>(false);
  const [showUpdateUserProfile, toggleUpdateUserProfile] = React.useState<boolean>(false);
  const [showSupervisorPin, toggleSupervisorPin] = React.useState<boolean>(false);
  const [pinStatus, setPinStatus] = React.useState<SupervisorPinStatusModel>();
  const { theme, onUpdateTheme, auth, logout } = useAppContext();
  // Chefs de gare (administrateurs ou superviseurs de gare) : entrée « PIN de chef de gare » dans le menu du compte.
  const loadPinStatus = React.useCallback(() => {
    apiSdk.SupervisorPinService.supervisorPin()
      .then(setPinStatus)
      .catch(() => setPinStatus(undefined));
  }, []);
  React.useEffect(() => {
    if (auth?.company?.id) loadPinStatus();
  }, [auth?.company?.id, loadPinStatus]);
  const SignOut = e => {
    e.preventDefault();
    logout();
  };
  const currentLanguage = React.useMemo(() => {
    if (i18n.language === 'en') {
      return languages[0];
    }
    return languages[1];
  }, [i18n.language]);
  const userContent = (
    <UserDropDwon>
      <div
        className="user-dropdwon"
        style={{ minWidth: 200 }}
        onClick={() => {
          toggleUserMenu(false);
        }}
      >
        <figure className="user-dropdwon__info">
          <figcaption>
            <h1>{auth?.firstName}</h1>
            <p>{auth?.email}</p>
          </figcaption>
        </figure>
        <ul className="user-dropdwon__links">
          <li>
            <Link
              to="#"
              onClick={e => {
                e.preventDefault();
                toggleUpdateUserProfile(true);
              }}
            >
              <FeatherIcon icon="user" /> {t('Profile')}
            </Link>
          </li>
          {window.innerWidth > 1200 ? (
            <li>
              <Link
                to="#"
                onClick={e => {
                  e.preventDefault();
                  onUpdateTheme({ topMenu: !theme.topMenu });
                }}
              >
                <FeatherIcon icon="layout" /> {t('Change_Layout')}
              </Link>
            </li>
          ) : null}

          <li>
            <Link
              to="#"
              onClick={e => {
                e.preventDefault();
                toggleChangePass(true);
              }}
            >
              <FeatherIcon icon="lock" /> {t('Change_Password')}
            </Link>
          </li>
          {pinStatus?.isStationSupervisor ? (
            <li>
              <Link
                to="#"
                onClick={e => {
                  e.preventDefault();
                  toggleSupervisorPin(true);
                }}
              >
                <FeatherIcon icon="key" /> {t('supervisorPin_Menu')}
              </Link>
            </li>
          ) : null}
        </ul>
        <Link className="user-dropdwon__bottomAction" onClick={SignOut} to="/cms/login">
          <FeatherIcon icon="log-out" /> {t('SignOut')}
        </Link>
      </div>
    </UserDropDwon>
  );

  return (
    <InfoWraper>
      <div className="nav-author">
        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '0 8px' }}>
          <LanguageSelector />
        </div>
        <Popover onVisibleChange={v => toggleUserMenu(v)} trigger="click" visible={showUserMenu} placement="bottomRight" content={userContent}>
          <AppAtag
            onClick={() => {
              toggleUserMenu(true);
            }}
            className="head-example d-flex "
            style={{ alignItems: 'center', color: '#272B41', display: 'flex' }}
          >
            <Badge dot status="success">
              <Avatar src="https://cdn-icons-png.flaticon.com/512/149/149071.png" alt={auth?.firstName} />
            </Badge>
          </AppAtag>
        </Popover>
      </div>
      {showUpdateUserProfile ? (
        <UpdateProfileModal
          onClose={() => {
            toggleUpdateUserProfile(false);
          }}
        />
      ) : null}
      {showSupervisorPin && pinStatus ? (
        <SupervisorPinModal
          status={pinStatus}
          onClose={changed => {
            toggleSupervisorPin(false);
            if (changed) loadPinStatus();
          }}
        />
      ) : null}
      {showChangePass ? (
        <ChangePasswordModal
          onClose={() => {
            toggleChangePass(false);
          }}
        />
      ) : null}
    </InfoWraper>
  );
};

export default AuthInfo;
